/**
 * Breakfast status for a rate plan — based ONLY on the backend field, never the name.
 *
 * Backend gives `BreakFastTypeName` (e.g. "Included" / "Not Included") which the
 * transformer maps to `plan.breakfast`. Problem: many hotels leave it "Not Included"
 * even when the rate NAME says "…with Breakfast" — so showing "No Breakfast Included"
 * is often wrong/contradictory.
 *
 * Rule (per product decision): only assert breakfast when the backend POSITIVELY
 * says it's included. Otherwise (Not Included / empty / unset) show NOTHING — never
 * assert "No Breakfast Included". We do NOT infer from the rate-plan name.
 *
 * @param {Object} plan - rate plan
 * @returns {boolean|null} true = included (show "Breakfast Included"); null = show nothing
 */
export const getBreakfastStatus = (plan) => {
  // Boolean flag from the transformer
  if (plan?.breakfast === true || plan?.breakfast === 1 || plan?.breakfast === '1') return true;

  // Raw backend field fallback (if transformer didn't set the boolean)
  const type = String(plan?.BreakFastTypeName || plan?.breakFastTypeName || plan?.breakfastType || '')
    .toLowerCase()
    .trim();
  if (
    type &&
    !type.includes('not') &&   // "Not Included"
    type !== 'none' &&
    type !== 'no' &&
    type !== '0' &&
    type !== 'excluded'
  ) {
    return true; // positive breakfast type (Included / Continental / Buffet / etc.)
  }

  // Not positively included → show nothing (never "No Breakfast Included")
  return null;
};
